import { Container, Typography, TypographyProps } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import BackButton from "components/BackButton/BackButton"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import styled from "styled-components"

// Styled Components

const StyledContainer = styled(Container)`
  padding: 0px;
  align-items: center;
`

const StyledBackButton = styled(BackButton)`
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 48px;
  }
`

const StyledTitle = styled(Typography)<{ variant?: string }>`
  text-align: right;
  margin-top: 20px;
  font-size: 40px;
  line-height: 46px;
  font-family: Speedee, NarkisBlock, sans-serif;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 0px;
  }
`
const StyledSubtitle = styled(Typography)<{ variant?: string }>`
  text-align: right;
  word-break: break-word;
  margin: 0;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: 400;
  color: #000000;
  font-size: 20px;
  font-family: Speedee, NarkisBlockCondensed, sans-serif;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`

interface GroupPurchasesHeaderProps {
  mainTitle?: string
  subTitle?: string | JSX.Element
  backBtnOnClick?: () => void
  alwaysShow?: boolean
  component?: TypographyProps["variant"]
  subtitleComponent?: TypographyProps["variant"]
}

const GroupPurchasesHeader = ({
  mainTitle,
  subTitle,
  backBtnOnClick,
  alwaysShow,
  component,
  subtitleComponent,
}: GroupPurchasesHeaderProps) => {
  const isDesktop = useIsDesktop()
  const { prevPath } = useGroupPurchasesContext()
  return (
    <>
      {(alwaysShow || isDesktop) && (
        <StyledContainer>
          <StyledBackButton
            linkText="חזרה"
            prevPath={prevPath}
            hideTextOnMobile={true}
            beforeNavigation={() => {
              backBtnOnClick && backBtnOnClick()
            }}
          />
        </StyledContainer>
      )}
      <StyledTitle variant={component || "h1"}>{mainTitle}</StyledTitle>
      {subTitle && (
        <StyledSubtitle variant={subtitleComponent || "h2"}>
          {subTitle}
        </StyledSubtitle>
      )}
    </>
  )
}

export default GroupPurchasesHeader
